import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Rótulo acessível para o `<section>` — usado quando há título visual. */
  titulo?: string;
}

export function Cartao({ children, titulo }: Props) {
  return (
    <section className="ui-cartao" aria-label={titulo}>
      {children}
    </section>
  );
}
